var EqServerDataFetcher = /** @class */ (function () {
    function EqServerDataFetcher(context) {
        this.context = context;
    }
    EqServerDataFetcher.prototype.fetchData = function (fetchOptions) {
        var query = fetchOptions.query || this.context.getQuery();
        var queryId = query.getId();
        var requestData = {
            'options': fetchOptions.options
        };
        if (typeof (fetchOptions.queryId) !== 'undefined') {
            requestData.queryId = fetchOptions.queryId;
        }
        else {
            requestData.query = query.toJSONData();
        }
        if (fetchOptions.debug) {
            requestData.debug = fetchOptions.debug;
        }
        if (fetchOptions.chunk) {
            requestData.chunk = fetchOptions.chunk;
        }
        if (fetchOptions.data) {
            requestData.data = fetchOptions.data;
        }
        if (typeof (fetchOptions.aux) != 'undefined') {
            requestData.aux = fetchOptions.aux;
        }
        var url = this.context.resolveEndpoint('FetchData', { modelId: query.getModel().getId(), queryId: queryId });
        var http = this.context.getServices().getHttpClient();
        return http.post(url, requestData)
            .then(function (data) { return data; });
    };
    return EqServerDataFetcher;
}());
export { EqServerDataFetcher };
//# sourceMappingURL=eqs_data_fetcher.js.map